import { Component, OnInit, ViewChild } from '@angular/core';
import { Seguro } from '../models/seguro';
import { MatPaginator, PageEvent } from '@angular/material';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { SeguroService } from '../services/seguro.service';
import { UtilitarioService } from '../services/utilitario.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-seguro',
  templateUrl: './seguro.component.html',
  styleUrls: ['./seguro.component.scss']
})
export class SeguroComponent implements OnInit {
  segurosFiltrados: Seguro[] = [];
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private seguroService: SeguroService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarSeguros();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  buscarSeguros() {
    this.carregandoService.mostra('buscarSeguros');

    this.seguroService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(
      dados => {
          this.segurosFiltrados = dados.itens;

          if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.carregandoService.esconde('buscarSeguros');
        },
      err => {
          this.carregandoService.esconde('buscarSeguros');
          this.notificacaoService.erro(err);
      }
    )
  }

  novoSeguro() {
    this.router.navigate(['/configuracoes/seguro/novo']);
  }

  editarSeguro(seguro) {
    this.router.navigate(['/configuracoes/seguro/editar', seguro.id]);
  }

  excluirSeguro(seguro: Seguro) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Seguro?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirSeguro');
        this.seguroService.excluir(seguro.id).subscribe(resp => {
          this.notificacaoService.sucesso('Seguro excluído com sucesso!!!');
          this.carregandoService.esconde('excluirSeguro');
          this.buscarSeguros();

        }, (erro) => {
          this.carregandoService.esconde('excluirSeguro');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarSeguros();
  }
}